import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import FrontendFAQForm from './FrontendFAQForm';
import TitleHeader from '../../../components/TitleHeader/TitleHeader'

class FrontendFAQ extends Component {
    render() {
        const columns = [
            { label: 'คำถาม', align: 'left', name: 'question', search_type: 'string' },
        ];

        const api_url = '/master/faq';

        return (
            <BrowserRouter>
                <div>
                    <TitleHeader program_name='FAQ' program_type='Frontend'></TitleHeader>
                    
                    <Route exact path={`${this.props.match.path}/`} component={() => (<DataTable columns={columns} allow_active={true} url={api_url}></DataTable>)} />
                    
                    <Route path={`${this.props.match.path}/create`} component={props => (<FrontendFAQForm {...props} url={api_url}></FrontendFAQForm>)} />
                    <Route path={`${this.props.match.path}/:id/edit`} component={props => (<FrontendFAQForm {...props} url={api_url}></FrontendFAQForm>)} />
                </div>
            </BrowserRouter>
        )
    }
}

export default FrontendFAQ
